import type { JSONContent } from '@tiptap/core'
import { textToJsonParagraphs } from '@/services/forms/tmTiptap/utils/textToJsonParagraphs'

export const textToJsonContent = (text: string, isJsonContent = false): JSONContent => ({
  type: 'doc',
  content: textToJsonParagraphs(text, isJsonContent),
})
